import React from "react";
import { bottomDrawerHelperActions } from "src/components/20-helper-views/bottom-drawer/useBottomDrawer";
import { snackbarHelperActions } from "src/components/20-helper-views/snackbar/useSnackbar";
import useStableCallback from "src/hooks/useCallbackUtils/useStableCallback";
import useI18n from "src/modules/translations/hooks/useI18n";
import DeleteNoteTabDrawer from "../components/DeleteNoteTabDrawer";
import NoteTabFormDrawer from "../components/NoteTabFormDrawer";
export default function useNoteTabActions(note) {
    const { translate } = useI18n();
    const addTab = useStableCallback((onSuccess) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(NoteTabFormDrawer, { noteID: note.id, onSuccess: (newTab) => {
                    bottomDrawerHelperActions.hide();
                    onSuccess(newTab);
                } })),
        });
    });
    const editTab = useStableCallback((tab) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(NoteTabFormDrawer, { noteID: note.id, noteTab: tab, onSuccess: () => {
                    bottomDrawerHelperActions.hide();
                } })),
        });
    });
    const deleteTab = useStableCallback((tab, onSuccess) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(DeleteNoteTabDrawer, { noteID: note.id, noteTab: tab, onDelete: () => {
                    snackbarHelperActions.show({
                        variant: 'POSITIVE',
                        duration: 'SHORT',
                        message: translate('Tab deleted successfully'),
                    });
                    onSuccess();
                } })),
        });
    });
    const state = {};
    const actions = {
        addTab,
        editTab,
        deleteTab,
    };
    return [state, actions];
}
